"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserEmailVerifyCodePopup = UserEmailVerifyCodePopup;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function UserEmailVerifyCodePopup(_ref) {
  var newEmail = _ref.newEmail,
    onUpdated = _ref.onUpdated,
    onClose = _ref.onClose;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    bind = _useValidatedForm.bind,
    register = _useValidatedForm.register;
  var onSubmit = function onSubmit() {
    if (!isValid()) {
      return;
    }
    feedbackContext.showBackdrop();
    var request = bind();
    (0, _api.verifyEmail)(request.code).then(function () {
      return (0, _api.confirmUpdateEmail)({
        access: access
      });
    }).then(function (user) {
      feedbackContext.showSuccess((0, _core.translate)('users.profile.updated_email'));
      onUpdated(user);
    })["catch"](function (error) {
      return (0, _core.cognitoErrorTranslator)(error, feedbackContext.showError);
    })["finally"](feedbackContext.closeBackdrop);
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: (0, _core.translate)('users.profile.verify_email_change'),
    open: true,
    onClose: onClose,
    button: {
      text: (0, _core.translate)('buttons.update'),
      onClick: onSubmit
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    paragraph: true
  }, (0, _core.translate)('users.profile.updating_email', {
    email: newEmail
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    type: "text",
    name: "code",
    label: (0, _core.translate)('users.profile.verification_code'),
    required: true,
    register: register
  }))));
}